import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getDefectCategories = createAsyncThunk(
  '/getDefectCategories',
  async () => {
    const response = await axios.get('/GetDefectCategories');
    return response.data;
  }
);

export const getDefectCategoryTypes = createAsyncThunk(
	'/getDefectCategoryTypes',
	async (categoryId) => {
    const response = await axios.get(`/GetDefectCategoryTypes/${categoryId}`);
    return response.data;
  }
);

export const getDefectsByCategoryAndType = createAsyncThunk(
	'/getDefectsByCategoryAndType',
	async (req) => {
    const response = await axios.get(`/GetDefectsByCategoryAndType/${req.CategoryId}/${req.TypeId}`);
    return response.data;
  }
);

export const setInterventionDefects = createAsyncThunk(
	'/setInterventionDefects',
	async (req) => {
    const response = await axios.post(`/SetInterventionDefects`, req);
    return response.data;
  }
);

export const getWarrantyTypes = createAsyncThunk(
	'/getWarrantyTypes',
	async () => {
    const response = await axios.get(`/GetWarrantyTypes`);
    return response.data;
  }
);

export const getInterventionControls = createAsyncThunk(
	'/getInterventionControls',
	async () => {
    const response = await axios.get(`/GetInterventionDefects`);
    return response.data;
  }
);

export const deleteInterventionControl = createAsyncThunk(
	'/deleteInterventionControl',
	async (req) => {
    const response = await axios.delete(`/DeleteInterventionDefect/${req.DefectId}/${req.WarrantyTypeId}`);
    return response.data;
  }
);

const interventionControlSlice = createSlice({
  name: 'interventionControl',
  initialState: {
    loading: false,
    error: '',
    DefectCategories: [],
		DefectCategoryTypes: [],
		DefectsByCategoryAndType: [],
		WarrantyTypes: [],
    InterventionControls: []
  },
  reducers: { 
    resetDescriptions(state) {
      state.DefectCategories = [];
			state.DefectCategoryTypes = [];
			state.DefectsByCategoryAndType = [];
			state.WarrantyTypes = []
      state.InterventionControls = []
    }
  },
  extraReducers: {
    [getDefectCategories.pending]: (state) => {
      state.loading = true;
    },
    [getDefectCategories.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefectCategories.fulfilled]: (state, action) => {
      state.DefectCategories = action.payload;
      state.loading = false;
    },
		[getDefectCategoryTypes.pending]: (state) => {
      state.loading = true;
    },
    [getDefectCategoryTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefectCategoryTypes.fulfilled]: (state, action) => {
      state.DefectCategoryTypes = action.payload;
      state.loading = false;
    },
		[getDefectsByCategoryAndType.pending]: (state) => {
      state.loading = true;
    },
    [getDefectsByCategoryAndType.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefectsByCategoryAndType.fulfilled]: (state, action) => {
      state.DefectsByCategoryAndType = action.payload;
      state.loading = false;
    },
		[getWarrantyTypes.pending]: (state) => {
      state.loading = true;
    },
    [getWarrantyTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWarrantyTypes.fulfilled]: (state, action) => {
      state.WarrantyTypes = action.payload;
      state.loading = false;
    },
    [setInterventionDefects.pending]: (state) => {
      state.loading = true;
    },
    [setInterventionDefects.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setInterventionDefects.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [getInterventionControls.pending]: (state) => {
      state.loading = true;
    },
    [getInterventionControls.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getInterventionControls.fulfilled]: (state, action) => {
      state.InterventionControls = action.payload;
      state.loading = false;
    },
    [deleteInterventionControl.pending]: (state) => {
      state.loading = true;
    },
    [deleteInterventionControl.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [deleteInterventionControl.fulfilled]: (state, action) => {
      state.loading = false;
    },
  }
});

export const interventionControlActions = interventionControlSlice.actions;
export default interventionControlSlice;